export function getTextResolution(): number {
  return Math.min(window.devicePixelRatio || 1, 2);
}
